import { Component, OnDestroy, OnInit } from '@angular/core';
import {
  isLargeScreen,
  updateCustomTableHeaders,
} from '../../../global.variable';
import { AddEditSiteComponent } from '../../shared/components/add-edit-site/add-edit-site.component';
import { ActivatedRoute, Router } from '@angular/router';
import { AppService } from '../../app.service';
import { ModalDialogueService } from '../../shared/components/modal-dialogue/modal-dialogue.service';
import { LoadingSpinnerService } from '../../shared/services/loading-spinner.service';
import { ToasterService } from '../../shared/services/toaster.service';
import { SitesService } from './sites.service';
import { firstValueFrom } from 'rxjs';
import { ClientsService } from '../../pages/pages/clients/clients.service';

@Component({
  selector: 'gtapp-sites',
  standalone: false,
  templateUrl: './sites.component.html',
  styleUrl: './sites.component.scss',
})
export class SitesComponent implements OnInit, OnDestroy {
  siteSearchString: string = '';

  previousSites: number = 0;
  rowsSites: number =
    this.appService.getUserData()?.preferences?.site_page_size || 10;
  pageNumSites: number = 1;
  totalPagesSites: number = 0;
  sortKeySites: any;
  searchParamsSites: any;
  totalSiteCount: number = 0;

  sitePaginationData: any = {};

  siteDetailsTableView: any = [];

  siteDropDownList: any = [];

  otherParamsSites: any = {
    apiFiltering: true,
  };

  largeView: Boolean = isLargeScreen;

  tableStyle = {
    'overflow': 'auto',
    'max-height': '75vh',
  };

  userData: any;

  archivedSiteExists: any;

  selectedSite: any = {};

  constructor(
    private siteService: SitesService,
    private spinnerService: LoadingSpinnerService,
    private appService: AppService,
    private router: Router,
    private route: ActivatedRoute,
    private toasterService: ToasterService,
    private dialogService: ModalDialogueService,
    private clientService: ClientsService,
  ) {
    this.formatRouteUrl();
    this.getTableDetails();
  }

  ngOnDestroy() {}
  ngOnInit() {
    this.getSiteListData();
  }
  getSitesCount(reqParams: any) {
    let params: any = { get_count: 1, ...reqParams };

    this.siteService.getSiteList(params).then((response: any) => {
      if (response['status'] == 'success') {
        this.otherParamsSites = {
          ...this.otherParamsSites,
          paginationData: {
            totalRows: response?.total_size,
            previousRows: this.previousSites,
            rows: this.rowsSites,
            pageNum: this.pageNumSites,
            totalPages: this.totalPagesSites,
          },
        };

        this.archivedSiteExists = response?.archived_sites || false;
        this.totalSiteCount = response?.site_count || 0;
      }
    });
  }

  getSiteListData(getCount = true) {
    let params: any = {};
    if (this.rowsSites) {
      params['rows'] = this.rowsSites;
      let userData = this.appService.getUserData()?.preferences?.site_page_size;
      if (userData?.preferences) {
        userData.preferences.site_page_size = this.rowsSites;
        this.appService.setUserData(userData);
      }
    }

    if (this.previousSites) {
      params['previous'] = this.previousSites;
    }
    if (this.siteSearchString) {
      params['search_str'] = this.siteSearchString;
    }

    if (this.sortKeySites) {
      params['sort_key'] = this.sortKeySites;
    }

    if (this.sitePaginationData?.[this.pageNumSites]?.length) return;
    if (getCount) this.getSitesCount(params);

    this.spinnerService.show();
    this.siteService.getSiteList(params).then((response: any) => {
      if (response['status'] == 'success') {
        this.sitePaginationData[this.pageNumSites] = [...response?.data];
        this.updateRoutPath();

        this.spinnerService.hide();
      } else {
        this.spinnerService.hide();
      }
    });
  }
  onChangePaginationSite(data: any) {
    this.previousSites = data?.paginationData?.previousRows;
    this.pageNumSites = data?.paginationData?.pageNum;
    if (data?.paginationData?.rows != this.rowsSites) {
      this.sitePaginationData = {};
    }
    this.rowsSites = data?.paginationData?.rows;

    this.otherParamsSites.paginationData = {
      ...data?.paginationData,
    };
    this.getSiteListData(false);
  }
  sortColumnSite(body: any) {
    this.sortKeySites = body?.sortList || [];
    this.searchParamsSites = body?.searchParams || {};
    this.siteSearchString = '';
    this.sitePaginationData = {};
    this.getSiteListData(false);
  }
  searchColumnSite(event: any) {
    this.searchParamsSites = event?.searchParams || {};
    this.clearValues();
    this.getSiteListData();
  }
  clearValues() {
    this.previousSites = 0;
    this.pageNumSites = 1;
    this.siteSearchString = '';
    this.sitePaginationData = {};
  }

  onSiteLookup(event: any) {
    if (event.target.value.length > 3) {
      let params: any = { search_str: event.target.value };

      this.siteService.getSiteList(params).then((res: any) => {
        this.siteDropDownList = res?.data || [];
      });
    }
  }
  async getPrimeContractor() {
    const response: any = await firstValueFrom(
      this.clientService.fetchCustomerList({ prime_contractors: 1, rows: 1 }),
    );

    return response?.data || [];
  }

  async openAddSiteForm() {
    const primeContractors: any = await this.getPrimeContractor();

    const primeContractor = primeContractors?.[0];
    if (!primeContractor) {
      this.toasterService.setMessage({
        errorMessage: '',
        successMessage: 'Prime Contractor Details Not Found',
      });
      return;
    }

    const dialogueRef = this.dialogService.open(AddEditSiteComponent, {
      data: {
        detailData: {
          company: primeContractor?.id,
          clientName: primeContractor?.company_name,
          primeContractor: true,
        },
      },
    });
    dialogueRef.afterClosed().subscribe((value: any) => {
      if (value !== false) {
        this.clearValues();
        this.spinnerService.show();
        setTimeout(() => {
          this.getSiteListData();
        }, 200);
      }
    });
  }

  openSiteView(site: any) {
    if (this.selectedSite?.id === site?.id) return;
    if (this.largeView) {
      this.selectedSite = null;
      setTimeout(() => {
        this.selectedSite = site;
      });

      return;
    }
    this.router.navigate(['/pc/view-site', { sKey: String(site?.id) }]);
  }

  updateRoutPath() {
    this.router.navigate([], {
      fragment: btoa(
        JSON.stringify({
          searchParams: this.searchParamsSites,
          otherParams: this.otherParamsSites,
          siteSearchString: this.siteSearchString,
        }),
      ),
      queryParams: {},
      replaceUrl: true,
    });
  }
  formatRouteUrl() {
    if (!this.route.snapshot.fragment) return;
    try {
      const urlFragmentDetails = JSON.parse(atob(this.route.snapshot.fragment));
      if (urlFragmentDetails && Object.keys(urlFragmentDetails)?.length) {
        this.searchParamsSites = {
          ...this.searchParamsSites,
          ...(urlFragmentDetails?.searchParams || {}),
        };

        this.siteSearchString = urlFragmentDetails?.siteSearchString || '';
        if (urlFragmentDetails?.otherParams?.paginationData) {
          this.previousSites =
            urlFragmentDetails?.otherParams?.paginationData?.previousRows ||
            this.previousSites;
          this.pageNumSites =
            urlFragmentDetails?.otherParams?.paginationData?.pageNum ||
            this.pageNumSites;
          this.rowsSites =
            urlFragmentDetails?.otherParams?.paginationData?.rows ||
            this.rowsSites;
        }
      }
    } catch (error) {}
  }
  getTableDetails() {
    let tableDetails = [
      {
        header: '',
        name: 'company_name',
        sortKey: 'company_name',
        // searchKey: 'company_name',
        sortOrder: 'asc',
        columnDataStyle: {
          'white-space': 'pre-line',
          'font-size': '18px',
        },

        tableColumnStyle: {
          'white-space': 'pre-line',
        },

        suffixNestedValue: (row: any) => {
          let suffixList = [''];
          if (row?.company?.company_name) {
            suffixList.push(row?.company?.company_name);
          }

          if (row?.address?.full_address) {
            suffixList.push(row?.address?.full_address);
          }
          return suffixList?.join('\n');
        },
        suffixStyle: {
          'font-size': 'small',
        },
      },
    ];

    updateCustomTableHeaders(tableDetails, this.searchParamsSites);

    this.siteDetailsTableView = [...tableDetails];
  }
}
